import ResponzaChannelInstagramAPI from '../../api/responzaChannelInstagram';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getConfigs: _state => _state.records,
  getUIFlags: _state => _state.uiFlags,
};

const actions = {
  async get({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await ResponzaChannelInstagramAPI.get();
      commit('SET_CONFIGS', response.data);
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, data) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await ResponzaChannelInstagramAPI.create(data);
      commit('ADD_CONFIG', response.data);
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await ResponzaChannelInstagramAPI.update(id, data);
      commit('UPDATE_CONFIG', response.data);
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await ResponzaChannelInstagramAPI.delete(id);
      commit('DELETE_CONFIG', id);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_CONFIGS(state, configs) {
    state.records = configs;
  },

  ADD_CONFIG(state, config) {
    state.records.push(config);
  },

  UPDATE_CONFIG(state, config) {
    const index = state.records.findIndex(c => c.id === config.id);
    if (index !== -1) {
      state.records.splice(index, 1, config);
    }
  },

  DELETE_CONFIG(state, id) {
    state.records = state.records.filter(c => c.id !== id);
  },

  SET_UI_FLAG(state, flags) {
    state.uiFlags = { ...state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
